import { useAuth } from '@context/AuthProvider';

export const useBroadcasting = () => {
  const { currentUser } = useAuth();
  const broadcasting = currentUser?.broadcasting;

  const channel = (name: string): string => {
    if (!broadcasting) {
      throw new Error('Broadcasting not loaded.');
    }

    return `${broadcasting.prefix}.${name}`;
  };

  return { channel };
};
